<template>
  <v-menu open-on-hover :location="location" max-width="650px">
    <template #activator="{ props }">
      <span class="stb-tooltip-i-content">
        <slot name="activator" :props="props">
          <span v-if="clickable && !disabled">
            <v-btn
              v-if="!disabled"
              v-bind="props"
              :id="id"
              :icon="iconId"
              :size="iconSize"
              variant="text"
              :color="iconColor"
              class="stb-tooltip-button"
              @click="onIconClicked"
            ></v-btn>
          </span>
          <v-icon
            v-else
            v-bind="props"
            :id="id"
            :size="clickableIconSize"
            :color="iconColor"
            :class="disabled ? 'action-disabled' : ''"
            class="stb-tooltip-button"
          >
            {{ iconId }}
          </v-icon>
        </slot>
      </span>
    </template>
    <div class="stb-icon-tooltip-content">
      <slot />
    </div>
  </v-menu>
</template>
<script>
export default {
  name: 'StbIconTooltip',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    },
    iconId: {
      type: String,
      required: false,
      default: 'fa:fas fa-info-circle'
    },
    location: {
      type: String,
      required: false,
      default: 'right'
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false
    },
    iconSize: {
      type: String,
      required: false,
      default: 'x-small'
    },
    iconColor: {
      type: String,
      required: false,
      default: 'black'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  emits: ['click'],
  computed: {
    clickableIconSize() {
      if (!this.clickable) {
        return this.iconSize;
      }
      switch (this.iconSize) {
        case 'x-small':
          return 'small';
        case 'small':
          return 'default';
        case 'default':
          return 'medium';
        case 'medium':
          return 'large';
        case 'large':
          return 'x-large';
        default:
          return this.iconSize;
      }
    }
  },
  methods: {
    onIconClicked() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.stb-icon-tooltip-content {
  background-color: rgb(255, 255, 255, 0.9) !important;
  color: gray !important;
  padding: 4px 12px;
  font-family: Gilroy;
  font-size: 14px;
  border-radius: 4px;
}

.stb-tooltip-i-content {
  font-family: 'Gilroy' !important;
  cursor: pointer;
}

.stb-tooltip-icon {
  width: auto;
  height: auto;
  margin-left: 8px;
  color: rgb(60, 55, 55, 0.54);
}

.stb-tooltip-button {
  width: auto;
  height: auto;
  padding: 8px;
  margin-left: 0px;
  color: rgb(60, 55, 55, 0.54);
}

.action-disabled {
  opacity: 0.25;
}
</style>
